module.exports = __webpack_public_path__ + "media/dashboard/assets/images/audio-off-e31da120e7b85bfe45640212d0f2022c.png";